import React from 'react';

import TooltipWrapper from 'src/components/TooltipWrapper';
import SpinnerButton from 'src/components/SpinnerButton';

interface Props {
    tip: string;
    disabled: boolean;
    spinning: boolean;
    isModified: boolean;
    isPublished: boolean;
    isEditingScene: boolean;
    isBulkMode: boolean;
    publishScene: () => void;
    saveAndPublishScene: () => void;
    createScene: () => void;
    createBulkScenes: () => void;
}

export default function publish({
    tip,
    disabled,
    spinning,
    isModified,
    isPublished,
    isEditingScene,
    isBulkMode,
    publishScene,
    saveAndPublishScene,
    createScene,
    createBulkScenes,
}: Props) {
    let text = 'Publish';
    let onClick = () => publishScene();

    if (isBulkMode) {
        text = 'Publish all backgrounds';
        onClick = () => createBulkScenes();
    } else if (!isEditingScene) {
        text = 'Create scene';
        onClick = () => createScene();
    } else if (isModified) {
        text = 'Save and publish';
        onClick = () => saveAndPublishScene();
    } else if (isPublished) {
        text = 'Published';
    }

    return (
        <div className='tools-publish'>
            <TooltipWrapper direction='top' contents={tip}>
                <SpinnerButton
                    testid='publish-button'
                    buttonType='primary'
                    onClick={onClick}
                    text={text}
                    disabled={disabled || !!tip}
                    spinning={spinning}
                />
            </TooltipWrapper>
        </div>
    );
}
